import {
  useEffect,
  useRef,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { BiRefresh } from "react-icons/bi";
import axios from "axios";
import { toastError, toastSuccess, toastWarning } from "../toaster";
import pathconfig from "../../pathconfig.json";
import { FaCheckCircle, FaExclamationCircle, FaCode, FaTimes } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { FaFloppyDisk, FaCircleCheck } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import packjson from "../../../package.json";
import { useAppContextProvider } from "../../contextapi";
import PDFViewerComponent from "./pdf-view";
import { processHTMLString } from "../editor/index";

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfEditor = forwardRef((props, ref) => {
  const [fileContent, setFileContent] = useState("");
  const [currentFile, setCurrentFile] = useState(null);
  const [compileAction, setCompileAction] = useState(true);
  const [showPdf, setShowpdf] = useState(false);
  // const [pdfData, setPdfdata] = useState(null)
  const [pdfStatus, setPdfStatus] = useState("");
  const saveButton = useRef(null);
  const CompileButton = useRef(null);
  const [time, setTime] = useState(0);
  const [timeComplete, setTimeComplete] = useState(false);
  const [timer, setTimer] = useState(false);
  const location = useLocation();
  const [downloadPercentage, setDownloadPercentage] = useState(0);
  const [downloadBar, setDownloadBar] = useState(false);
  const [showconfirm, setConfirm] = useState(false);
  const [showProgress, setShowprogress] = useState(false);
  // Ref mirror of showProgress so window-level keyboard handlers (registered
  // once) can read the CURRENT progress state without stale-closure issues.
  const showProgressRef = useRef(false);
  useEffect(() => {
    showProgressRef.current = showProgress;
  }, [showProgress]);
  // const [trackValue, setTrackvalue] = useState([]);
  const [trackSpreate, setTrackSpreate] = useState({});
  const [submitData, setSubmitData] = useState(false);
  const initialLatexRef = useRef(null);
  const authorQueryRef = useRef([]);
  const [progressDetails, setProgressDetails] = useState(
    "Please wait file is progess to submit.",
  );
  const [saveStatus, setSaveStatus] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [announcement, setAnnouncement] = useState("");
  const navigate = useNavigate();
  const {
    userProfile,
    authorQuery,
    microSave,
    setMicroSave,
    setSavedFileContentData,
    fullData,
    saveTrigger,
    setSaveTrigger,
    trackContents,
    trackChanges,
    editorContent,
    setLayout,
    editorStyle,
    readOnly,
    supplementaryData,
    changedComment,
    pdfContent,
    setPdfContent,
    inlpActions,
    supplementComment,
    alttextEnabled,
    altTextFlow
  } = useAppContextProvider();
  let CompileCode = true;
  let CompileCheck = true;
  const renderCount = useRef(0);
  const yesBtnRef = useRef(null);
  useImperativeHandle(ref, () => ({
    saveDocument: async () => {
      return await onSave();
    },
  }));
  const isAuthor = userProfile?.role === "Author";
  const isMC = userProfile?.role === "Master Copier";

  useEffect(() => {
    authorQueryRef.current = authorQuery || [];
  }, [authorQuery]);
  // Focus the Yes button when the confirmation modal opens
  useEffect(() => {
    if (showconfirm && yesBtnRef.current) {
      yesBtnRef.current.focus();
    }
  }, [showconfirm]);
  const compileCode = async (value, isRetry = false) => {
    // Guard: never start a second compilation while one is in progress
    // (covers the Ctrl+Shift+J shortcut, double-clicks, and any other caller).
    // isRetry skips the guard for the internal "Uncited Element" re-compile.
    if (!isRetry && showProgressRef.current) {
      toastWarning("Compilation is already in progress. Please wait for it to finish.");
      return;
    }
    // Close error log when compilation starts
    if (props.closeErrorOnCompile) {
      props.closeErrorOnCompile();
    }

    if (userProfile.role === "Author") {
      if (CompileCheck && value !== "submitHandle") {
        let validationItem = await validationcheck("compilercheck", value);
        if (validationItem?.length > 0) {
          return;
        }
      }
    }

    const docId = userProfile.docid;
    const GetDetailDataString = localStorage.getItem(
      `${docId}_init-getdetails`,
    );
    const GetDetailData = GetDetailDataString
      ? JSON.parse(GetDetailDataString)
      : {};
    const WorkFlowID = GetDetailData?.ActivtyDetails?.WfdID;
    let updatedFileContent;
    if (WorkFlowID === 84 || WorkFlowID === 85) {
      updatedFileContent = fileContent.replace(
        /\\documentclass\[([^\]]*)\]\{([^\}]*)\}/,
        (match, options, className) => {
          // Convert options to an array, add "authorproof" if not already present
          const optionsArray = options.split(",").map((opt) => opt.trim());
          if (!optionsArray.includes("authorproof")) {
            optionsArray.push("authorproof");
          }
          const newOptions = optionsArray.join(",");
          return `\\documentclass[${newOptions}]{${className}}`;
        },
      );
    }
    setCompileAction(false);
    setTimer(true);
    setTime(0);
    setCompileAction(true);
    setTimeComplete(false);
    setProgressDetails(
      !CompileCode
        ? "Uncited Element Found. Please wait Re-compiler in progress."
        : "Please wait compiler in progress.",
    );
    setShowprogress(true);
    // Sync the ref immediately — the state update above only reaches the ref
    // on the next render, and the shortcut could fire again before that.
    showProgressRef.current = true;
    if (value === "submitHandle") {
      setProgressDetails("Please wait auto compiler in progress.");
      setShowprogress(true);
    }
    try {
      if (!fileContent || !currentFile) {
        toastError(
          `Cannot able to fetch the file for compiling. Please contact journal manager`,
        );
        setCompileAction(false);
        return;
      }
      console.log(fileContent, "fileContentd");
      // let tagInsertion = await trackchangeTagInsertion(fileContent, props.trackData)
      let data = {
        data:
          updatedFileContent != undefined ? updatedFileContent : fileContent,
        filename: userProfile.docid,
        is_Submit: value === "submitHandle" ? true : false,
        role: userProfile.role,
        is_linkGeneration: false,
      };
      const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].compiler_api}`;
      const response = await axios.post(url, data);
      // If the code reaches here, it means the compile was successful
      try {
        const pdfResponse = await blobUpload(response.data);
        //setPdfdata(response.data.pdfBase64);
        props.LogDataFile(true);
        setPdfContent(response.data.pdfBase64);
        let logContent = atob(response.data.logBase64);
        let checkText = "LaTeX Warning: There were undefined references";
        if (CompileCode) {
          if (logContent.includes(checkText)) {
            setProgressDetails(
              "Uncited Element Found. Please wait Re-compiler in progress.",
            );
            // setCompileCode(true)
            CompileCheck = false;
            CompileCode = false;
            setShowprogress(true);
            await compileCode(undefined, true);
            setShowprogress(false);
          }
        }
        // setBase64LogContent(response.data.logBase64)
        if (response.data?.errors.length === 0) {
          setPdfStatus("success");
          if (value === "submitHandle") {
            setSubmitData(true);
            setProgressDetails("Please wait file is progess to submit.");
            setShowprogress(false);
          } else {
            toastSuccess(`Compilation completed Successfully.`);
            setShowprogress(false);
          }
          setShowpdf(true);
          setTimeComplete(true);
          setPdfStatus("");
          setCompileAction(false);
          // Call onSave after successful compilation
          await onSave();
        } else if (
          response.data.errors.filter((item) => item.type == "Error").length ==
          0
        ) {
          if (response.data && response.data.errors && response.data.errors) {
            if (
              Array.isArray(response.data.errors) ||
              typeof response.data.errors === "object"
            ) {
              props.compileError(response.data.errors);
            }
          }
          if (value === "submitHandle") {
            setSubmitData(true);
            setProgressDetails("Please wait file is progess to submit.");
            setShowprogress(false);
          } else {
            setPdfStatus("error");
            toastSuccess(
              `The file has been successfully compiled with warnings.`,
            );
            setShowprogress(false);
            CompileCode = true;
          }
          setShowpdf(true);
          setTimeComplete(true);
          setPdfStatus("");
          setCompileAction(false);
          // Call onSave after compilation with warnings
          await onSave();
        } else {
          if (response.data && response.data.errors && response.data.errors) {
            if (
              Array.isArray(response.data.errors) ||
              typeof response.data.errors === "object"
            ) {
              props.compileError(response.data.errors);
            }
          }
          setPdfStatus("error");
          // toastSuccess(`The file has been successfully compiled with Errors.`);
          toastWarning(`Compiled with errors. Check the log for details.`);
          setCompileAction(false);
          setShowprogress(false);
          CompileCode = true;
          setPdfStatus("");
          if (value === "submitHandle") {
            setProgressDetails("Please wait file is progess to submit.");
            setShowprogress(false);
          }
          // Call onSave even after compilation with errors
          await onSave();
        }
      } catch (error) {
        // Handle the error from blobupload here
        toastError(`upload error - ${error.message}`);
        throw new Error(`upload error - ${error.message}`);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.details
      ) {
        if (
          Array.isArray(error.response.data.details) ||
          typeof error.response.data.details === "object"
        ) {
          props.compileError(error.response.data.details);
        }
      }
      toastError(`Error compiling code - ${error.message}`);
      setPdfStatus("error");
      setCompileAction(false);
      setShowprogress(false);
      setPdfStatus("");
    }
  };

  useEffect(() => {
    if (downloadBar === true) {
      let percentage = 0;
      const interval = setInterval(() => {
        percentage++;
        setDownloadPercentage(percentage);
        if (percentage >= 100) {
          clearInterval(interval);
        }
      }, 50);
    }
  }, [downloadBar]);

  useEffect(() => {
    if (trackChanges || props.fileItems || changedComment) {
      // Set initial track value
      // setTrackvalue(props.trackData);

      const docId = userProfile.docid;
      const GetDetailDataString = localStorage.getItem(
        `${docId}_init-getdetails`,
      );
      const GetDetailData = GetDetailDataString
        ? JSON.parse(GetDetailDataString)
        : {};
      const WorkFlowID = GetDetailData?.ActivtyDetails?.WfdID;

      const filterByRole = (role) => {
        // Filter track data based on WorkFlowID and role
        const TrackValue = trackChanges?.filter((item) => {
          if (WorkFlowID === 85 && role === "Editor") {
            return ["Author", "Editor"].includes(item.role);
          }
          return item?.role === role;
        });
        // Filter comments based on WorkFlowID and role
        const Comment = changedComment?.comment?.filter((item) => {
          if (WorkFlowID === 85 && role === "Editor") {
            return ["Author", "Editor"].includes(item.role);
          }
          return item?.role === role;
        });

        // Filter attachments based on role
        const Attachment =
          props.fileItems?.filter((item) => {
            const roleArray = JSON.parse(item?.Rolename);
            const roleName = roleArray[0].RoleName;
            if (WorkFlowID === 85 && role === "Editor") {
              return ["Author", "Editor"].includes(roleName);
            }
            return roleName === role;
          }) || [];

        const AttachementFilterImage = Attachment.filter(
          (item) => item?.AttachType === "imageAttachment",
        );
        const AttachementFilterTxt = Attachment.filter(
          (item) =>
            item?.AttachType === "textAttachment" ||
            item?.AttachType === "commentAttachment",
        );
        // Calculate specific lengths for "Editor" role
        const CommentLen = Comment?.filter((item) => item?.role === "Editor");
        const TrackLen = TrackValue?.filter((item) => item?.role === "Editor");

        return {
          AuthorQuery: authorQuery,
          TrackValue,
          Comment,
          Attachment,
          CommentLen,
          TrackLen,
          AttachementFilterImage,
          AttachementFilterTxt,
        };
      };

      // Get filtered results based on user role
      const filteredResults = filterByRole(userProfile.role);

      // Filter for deletions and insertions
      const deletion =
        filteredResults.TrackValue?.filter(
          (item) => item.type === "deletion",
        ) || [];

      const insertion =
        filteredResults.TrackValue?.filter(
          (item) => item.type === "insertion",
        ) || [];
      // filter by editor role
      const deletionEditor =
        filteredResults.TrackLen?.filter((item) => item.type === "deletion") ||
        [];
      const insertionEditor =
        filteredResults.TrackLen?.filter((item) => item.type === "insertion") ||
        [];
      // Set track separation values
      setTrackSpreate({
        Comment: filteredResults.Comment?.length || 0,
        AuthorQuery: filteredResults.AuthorQuery?.length || 0,
        deletion: deletion?.length || 0,
        insertion: insertion?.length || 0,
        deletionEditor: deletionEditor?.length || 0,
        insertionEditor: insertionEditor?.length || 0,
        editorTrackTotal: deletionEditor?.length + insertionEditor?.length,
        commentEditor: filteredResults.CommentLen?.length || 0,
        Attachment: filteredResults.Attachment?.length || 0,
        AttachmentEditor: filteredResults.Attachment?.length || 0,
        AttachementFilterImage: filteredResults.AttachementFilterImage.length,
        AttachementFilterTxt: filteredResults.AttachementFilterTxt.length,
      });
    }
  }, [trackChanges, props.fileItems, changedComment]);

  useEffect(() => {
    if (props.downloadTrigger === true) {
      pdfDownlad();
    }
  }, [props.downloadTrigger]);

  useEffect(() => {
    if (editorStyle) {
      setFileContent(editorStyle);
    }
  }, [editorStyle]);

  const onSave = useCallback(async () => {
    props.fileSave(true);
    window.autoSaveInProgress = true;
    setSaveStatus(false);
    let isSuccess = false;
    try {
      if (!fileContent || !currentFile) {
        toastError(
          `Cannot able to fetch the file for compiling. Please contact journal manager`,
        );
        return false;
      }
      const docId = userProfile.docid;
      let GetDetailDataString = localStorage.getItem(
        `${docId}_init-getdetails`,
      );
      let GetDetailData = JSON.parse(GetDetailDataString || "{}");
      let authorquerys = authorQueryRef.current;
      // Prefer the editor's live comments: changedComment lags behind and is
      // stale when the user goes idle right after adding/editing a comment.
      // getLatestComments() returns null/undefined when it has nothing reliable
      // (initial-TeX view, comments not loaded yet) — fall back, never send "null".
      let comments = props.getLatestComments?.() || changedComment;
      // let inplcontent = inplContent;
      // let blobcomments = commentRange;
      let Trackchange = trackChanges;
      let supplementComments = supplementComment;
      // Build a save-time altTextContent clone that includes initialShort/initialLong
      // captured from the initial LaTeX snapshot so we can compare later.
      const parseLatexAltText = (latex) => {
        const readBalanced = (str, start) => {
          if (str[start] !== "{") return null;
          let depth = 0;
          let i = start;
          while (i < str.length) {
            if (str[i] === "{") depth++;
            else if (str[i] === "}") depth--;
            if (depth === 0) {
              return {
                value: str.slice(start + 1, i),
                from: start + 1,
                to: i,
                endIndex: i,
              };
            }
            i++;
          }
          return null;
        };

        // \alttext carries an optional language code:
        //   \alttext[<language code>]{MODIFIED}{short}{alt-text content}
        // Returns { value, nextIndex }; value is "" and nextIndex is `start`
        // when no optional argument is present.
        const readOptionalArg = (str, start) => {
          let i = start;
          while (i < str.length && /\s/.test(str[i])) i++;
          if (str[i] !== "[") return { value: "", nextIndex: start };
          const close = str.indexOf("]", i);
          const nextBrace = str.indexOf("{", i);
          // Malformed (unclosed, or running past the first mandatory group) —
          // treat the macro as having no optional argument.
          if (close === -1 || (nextBrace !== -1 && close > nextBrace)) {
            return { value: "", nextIndex: start };
          }
          return { value: str.slice(i + 1, close).trim(), nextIndex: close + 1 };
        };

        const result = {};
        const beginBlockRegex =
          /^(?!\s*%).*\\begin\{(figure\*?|sidewaysfigure\*?|altecom|pdfxml)\}[\s\S]*?\\end\{\1\}/gm;
        // const inlineFigureRegex = /\\inlinefigure\s*\{(?:[^{}]|\{[^{}]*\})*\}/g;
        // Lookbehind skips commented-out copies (unescaped % earlier on the line).
        const inlineFigureRegex = /(?<!(?:^|[^\\])%[^\n]*)\\inlinefigure\s*\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/gs;

        const processBlock = (block, blockStartIndex) => {
          let short = null;
          let long = null;
          let fileName = null;
          let cursor = 0;

          while ((cursor = block.indexOf("\\alttext", cursor)) !== -1) {
            // \alttext[<language code>]{type}{variant}{text} — step over the
            // optional language code before the three mandatory groups.
            const langObj = readOptionalArg(block, cursor + "\\alttext".length);
            const lang = langObj.value;

            const typeStart = block.indexOf("{", langObj.nextIndex);
            const typeObj = readBalanced(block, typeStart);

            const variantObj = typeObj && readBalanced(block, typeObj.endIndex + 1);
            const textObj = variantObj && readBalanced(block, variantObj.endIndex + 1);

            if (!textObj) break;
            const type = typeObj.value.trim();
            const variant = variantObj.value.trim().toLowerCase();
            const absoluteFrom = blockStartIndex + textObj.from;
            const absoluteTo = blockStartIndex + textObj.to;
            if (variant === "short"){
              short = {
                type,
                lang,
                value: textObj.value.trim(),
                from: absoluteFrom,
                to: absoluteTo,
              };
            }
            if (variant === "long"){
              long = {
                type,
                lang,
                value: textObj.value.trim(),
                from: absoluteFrom,
                to: absoluteTo,
              };
            }
            cursor = textObj.endIndex + 1;
          }

          const incIndex = block.indexOf("\\includegraphics");
          if (incIndex !== -1) {
            const braceStart = block.indexOf("{", incIndex);
            const fileObj = readBalanced(block, braceStart);
            if (fileObj) fileName = fileObj.value.trim();

            // Add .pdf if extension is missing
            if (fileName && !/\.[a-zA-Z0-9]+$/.test(fileName)) {
              fileName += ".pdf";
            }
          }

          if (fileName) result[fileName] = { short, long };
        };

        let match;
        const beginBlockRanges = [];
        while ((match = beginBlockRegex.exec(latex)) !== null) {
          beginBlockRanges.push([match.index, match.index + match[0].length]);
          processBlock(match[0], match.index);
        }
        while ((match = inlineFigureRegex.exec(latex)) !== null) {
          // Skip an \inlinefigure already read with its enclosing environment (pdfxml).
          if (beginBlockRanges.some(([from, to]) => match.index >= from && match.index < to)) continue;
          processBlock(match[0], match.index);
        }
        return result;
      };

      // Get the initial LaTeX content to capture the original alt text values before any edits were made.
      const originalSource = await getInitialLatexContent() ||"";
      // originalMap is used to fetch the initial short/long values for alt text.
      const originalMap = parseLatexAltText(originalSource);
      console.log(originalMap, "<<originalMap>>")

      //Clone the alt text from the current content and enrich with verified short/long from props.altTextContent, but only if they are not already present in the current content. This allows us to preserve any new edits while ensuring verified alt text is included for saving.
       const clonedAltText = parseLatexAltText(fileContent)
       console.log(clonedAltText, "<<clonedAltText>>")

      const clonedAltForSave = JSON.parse(
        JSON.stringify(props.altTextContent || {}),
      );
      console.log(clonedAltForSave, "<<clonedAltForSave before enrichment>>")

      Object.keys(clonedAltForSave).forEach((key) => {
        const saveItem = clonedAltForSave[key];

        if (saveItem?.verified) {
          clonedAltText[key] = {
            ...(clonedAltText[key] || {}),
            short: clonedAltText[key].short,
            long: clonedAltText[key].long,
            verified: true
          };
        }

        if (userProfile.role === "Master Copier") {
          const actionBtn =
            saveItem?.actionBtn ??
            (saveItem?.isEdited === true ? "validate" : "skip");
          clonedAltText[key] = {
            ...(clonedAltText[key] || {}),
            ...(saveItem?.isEdited === true && { isEdited: true }),
            ...(saveItem?.comment != null && { comment: saveItem.comment }),
            ...(saveItem?.mcValidated != null && { mcValidated: saveItem.mcValidated }),
            actionBtn,
          };
        }
      });

      console.log(clonedAltText, "<<clonedAltText after enrichment>>")

      console.log(clonedAltForSave, "<<clonedAltForSave before enrichment>>")

      attachInitialAltText(clonedAltText, originalMap, !!originalSource, clonedAltForSave);

      let data = {
        htmlcontent: fileContent,
        QueryContent: JSON.stringify(authorquerys),
        CommentContent: JSON.stringify(comments),
        //BlobComment: JSON.stringify(blobcomments),
        trackChanges: JSON.stringify(Trackchange),
        supplementComments: JSON.stringify(supplementComments),
        supplementary: JSON.stringify(supplementaryData),
        inlpContent: JSON.stringify(inlpActions),
        // Save-time payload: include initialShort/initialLong for later comparisons.
        // Sent whenever the document is in the alt-text flow (every role), so the
        // stored alt text is preserved even for roles that cannot change it.
        ...(altTextFlow && { altTextContent: JSON.stringify(clonedAltText || {}) }),
        istexfile: true,
        docid: docId,
        activityID: GetDetailData.ActivtyDetails.ActivityID,
        isAutoSave: false,
        ArticleGUID: GetDetailData.Articledetails.ArticleGUID,
      };
      const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].save_api}`;

      await axios
        .post(url, data)
        .then(({ data }) => {
          props.fileSave(false);
          props.fileSaveStatus(true);
          setSaveTrigger(false);
          setSaveStatus(data.is_success === false ? true : true);
          //toastSuccess(`Saved Successfully.`)
          setSavedFileContentData(fileContent);
          isSuccess = true;
        })
        .catch((error) => {
          props.fileSave(false);
          toastError(`Error compiling code - ${error.message}`);
          isSuccess = false;
        });
    } catch (error) {
      toastError(`Error compiling code - ${error.message}`);
      isSuccess = false;
    } finally {
      window.autoSaveInProgress = false;
      document.body.removeAttribute("data-saving");
    }
    return isSuccess;
  }, [fileContent, currentFile, location.search, props, authorQuery, changedComment, trackChanges, supplementaryData, inlpActions, userProfile, supplementComment, altTextFlow]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "s") {
        event.preventDefault();
        onSave();
      }
      // Ctrl+Shift+J -> Compile (triggers the Compile button, respecting its state)
      if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.code === "KeyJ") {
        event.preventDefault();
        // Block the shortcut while a compile/submit is already running —
        // the "Please Wait" overlay stops mouse clicks, but keyboard
        // shortcuts bypass it and would start a second compilation.
        if (showProgressRef.current) {
          toastWarning("Compilation is already in progress. Please wait for it to finish.");
          return;
        }
        CompileButton.current?.click();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onSave]);

  async function blobUpload(responseData) {
    try {
      const docId = userProfile.docid;
      const GetDetailDataString = localStorage.getItem(
        `${docId}_init-getdetails`,
      );
      const GetDetailData = JSON.parse(GetDetailDataString);
      const outPath = GetDetailData.Articledetails.OutputPath.substring(
        0,
        GetDetailData.Articledetails.OutputPath.lastIndexOf("/"),
      );
      const filename = GetDetailData.Articledetails.ArticleName;
      const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].blobPDFupload}`;
      const data = {
        docid: docId,
        outPath: outPath,
        filename: filename,
      };
      const response = await axios.post(url, data);
      console.log(response.data);
      // if (response.data.length) {
      //     console.log(response.data)
      //     toastSuccess(`Files saved successfully.`);
      // };
      return response;
    } catch (error) {
      // throw new Error(`Upload error - ${error.message}`);
      console.log(`Upload error - ${error.message}`);
    }
  }

  async function trackchangeTagInsertion(
    fileContent,
    trackvalue,
    commentsValue,
    value,
  ) {
    try {
      let latexContent = fileContent;
      // latexContent = latexContent.replace(/(\r\n)+/ig, '\r\n');
      // latexContent = latexContent.replace(/(\n)+/ig, '\n');
      // latexContent = latexContent.replace(/^\t/img, '');
      let ranges = [...(trackvalue || []), ...(commentsValue || [])];
      let trachranges = ranges.sort((a, b) => {
        if (a.from === b.from) {
          return b.to - a.to;
        }
        return b.from - a.from;
      });
      const extractDeletionText = (decoration) => {
        return (
          decoration?.widget?.text ||
          decoration?.spec?.widget?.text ||
          decoration?.spec?.text ||
          ""
        );
      };
      const insertText = (originalText, range, type) => {
        let before = originalText.slice(0, range.from);
        let after = originalText.slice(range.to);
        if (value === true) {
          if (type === "cmt") {
            return (
              before +
              `\\cmt[${JSON.stringify(range).replace(/\\"/g, 'itempslash"').replace(/_/g, "\\_").replace(/\$/g, "\\$").replace(/%/g, "\\%").replace(/#/g, "\\#").replace(/\[/g, "iosb").replace(/\]/g, "icsb").replace(/\{/g, "iocb").replace(/\}/g, "iccb")}]{` +
              range.selectText +
              "}" +
              after
            );
          } else if (type === "del")
            return (
              before +
              `\\del[${JSON.stringify(range).replace(/\\"/g, 'itempslash"').replace(/_/g, "\\_").replace(/\$/g, "\\$").replace(/%/g, "\\%").replace(/#/g, "\\#").replace(/\[/g, "iosb").replace(/\]/g, "icsb").replace(/\{/g, "iocb").replace(/\}/g, "iccb")}]{` +
              range.decoration.spec.text +
              "}" +
              after
            );
          else {
            return (
              before +
              `\\ins[${JSON.stringify(range).replace(/\\"/g, 'itempslash"').replace(/_/g, "\\_").replace(/\$/g, "\\$").replace(/%/g, "\\%").replace(/#/g, "\\#").replace(/\[/g, "iosb").replace(/\]/g, "icsb").replace(/\{/g, "iocb").replace(/\}/g, "iccb")}]{` +
              range.text +
              "}" +
              after
            );
          }
        } else {
          if (type === "del")
            return before + "\\del{" + range.decoration.spec.text + "}" + after;
          else {
            return before + "\\ins{" + range.text + "}" + after;
          }
        }
      };
      for (const range of trachranges) {
        if (range.cmdtype === "Comments") {
          latexContent = insertText(latexContent, range, "cmt");
        } else if (range.type === "insertion") {
          latexContent = insertText(latexContent, range, "ins");
        } else {
          latexContent = insertText(latexContent, range, "del");
        }
      }
      console.log(latexContent);
      return latexContent;
    } catch (error) {
      throw new Error(`trackchange tag insertion error - ${error.message}`);
    }
  }
  useEffect(() => {
    if (submitData) {
      const parseLatexAltText = (latex) => {
        const readBalanced = (str, start) => {
          if (str[start] !== "{") return null;
          let depth = 0;
          let i = start;
          while (i < str.length) {
            if (str[i] === "{") depth++;
            else if (str[i] === "}") depth--;
            if (depth === 0) {
              return {
                value: str.slice(start + 1, i),
                from: start + 1,
                to: i,
                endIndex: i,
              };
            }
            i++;
          }
          return null;
        };

        // \alttext carries an optional language code:
        //   \alttext[<language code>]{MODIFIED}{short}{alt-text content}
        // Returns { value, nextIndex }; value is "" and nextIndex is `start`
        // when no optional argument is present.
        const readOptionalArg = (str, start) => {
          let i = start;
          while (i < str.length && /\s/.test(str[i])) i++;
          if (str[i] !== "[") return { value: "", nextIndex: start };
          const close = str.indexOf("]", i);
          const nextBrace = str.indexOf("{", i);
          // Malformed (unclosed, or running past the first mandatory group) —
          // treat the macro as having no optional argument.
          if (close === -1 || (nextBrace !== -1 && close > nextBrace)) {
            return { value: "", nextIndex: start };
          }
          return { value: str.slice(i + 1, close).trim(), nextIndex: close + 1 };
        };

        const result = {};
        const beginBlockRegex =
          /^(?!\s*%).*\\begin\{(figure\*?|sidewaysfigure\*?|altecom|pdfxml)\}[\s\S]*?\\end\{\1\}/gm;
        // const inlineFigureRegex = /\\inlinefigure\s*\{(?:[^{}]|\{[^{}]*\})*\}/g;
        // Lookbehind skips commented-out copies (unescaped % earlier on the line).
        const inlineFigureRegex = /(?<!(?:^|[^\\])%[^\n]*)\\inlinefigure\s*\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})*\}/gs;

        const processBlock = (block, blockStartIndex) => {
          let short = null;
          let long = null;
          let fileName = null;
          let cursor = 0;

          while ((cursor = block.indexOf("\\alttext", cursor)) !== -1) {
            // \alttext[<language code>]{type}{variant}{text} — step over the
            // optional language code before the three mandatory groups.
            const langObj = readOptionalArg(block, cursor + "\\alttext".length);
            const lang = langObj.value;

            const typeStart = block.indexOf("{", langObj.nextIndex);
            const typeObj = readBalanced(block, typeStart);

            const variantObj = typeObj && readBalanced(block, typeObj.endIndex + 1);
            const textObj = variantObj && readBalanced(block, variantObj.endIndex + 1);

            if (!textObj) break;
            const type = typeObj.value.trim();
            const variant = variantObj.value.trim().toLowerCase();
            const absoluteFrom = blockStartIndex + textObj.from;
            const absoluteTo = blockStartIndex + textObj.to;
            if (variant === "short") {
              short = {
                type,
                lang,
                value: textObj.value.trim(),
                from: absoluteFrom,
                to: absoluteTo,
              };
            }
            if (variant === "long") {
              long = {
                type,
                lang,
                value: textObj.value.trim(),
                from: absoluteFrom,
                to: absoluteTo,
              };
            }
            cursor = textObj.endIndex + 1;
          }

          const incIndex = block.indexOf("\\includegraphics");
          if (incIndex !== -1) {
            const braceStart = block.indexOf("{", incIndex);
            const fileObj = readBalanced(block, braceStart);
            if (fileObj) fileName = fileObj.value.trim();

            // Add .pdf if extension is missing
            if (fileName && !/\.[a-zA-Z0-9]+$/.test(fileName)) {
              fileName += ".pdf";
            }
          }

          if (fileName) {
            result[fileName] = { short, long };
          }
        };

        let match;
        const beginBlockRanges = [];
        while ((match = beginBlockRegex.exec(latex)) !== null) {
          const block = match[0];
          const blockStartIndex = match.index;
          beginBlockRanges.push([blockStartIndex, blockStartIndex + block.length]);
          processBlock(block, blockStartIndex);
        }
        while ((match = inlineFigureRegex.exec(latex)) !== null) {
          const block = match[0];
          const blockStartIndex = match.index;
          // Skip an \inlinefigure already read with its enclosing environment (pdfxml).
          if (beginBlockRanges.some(([from, to]) => blockStartIndex >= from && blockStartIndex < to)) continue;
          processBlock(block, blockStartIndex);
        }
        return result;
      };

      const submitFun = async () => {
        setShowprogress(true);
        try {
          const docId = userProfile.docid;
          let GetDetailDataString = localStorage.getItem(
            `${docId}_init-getdetails`,
          );
          let GetDetailData = JSON.parse(GetDetailDataString);
          const OutputPath = GetDetailData.Articledetails.OutputPath;
          const ActivityName = GetDetailData.ActivtyDetails.ActivityName;
          const lastSlashIndex = OutputPath.lastIndexOf("/");
          const OutputdirectoryPath = OutputPath.substring(0, lastSlashIndex);
          const OutputPathfileName = OutputPath.substring(lastSlashIndex + 1);
          let pageInfoData = await fetchPageInfoData(OutputPath);
          let totalPage = extractTotalPage(pageInfoData);
          let authorquerys = authorQueryRef.current;
          // Same fallback as save: never send "null" as CommentContent.
          let comments = props.getLatestComments?.() || changedComment;
          // let blobcomments = commentRange;
          let trackchange = trackChanges;
          let supplementComments = supplementComment;
          let tagInsertion = ["L2 QA", "Master Copier"].includes(ActivityName)
            ? await trackchangeTagInsertion(
                fileContent,
                trackChanges,
                changedComment.comment,
                submitData,
              )
            : fileContent;
          // Build a submit-only altTextContent clone with isEdited flags
          // Use the initial LaTeX snapshot if available so edits made by
          // updateAltTextWithTracking don't become the "original" value.
            const originalSource = await getInitialLatexContent() ||"";
            // initialLatexRef.current || fullData?.Content || "";
          const originalMap = parseLatexAltText(originalSource);

          //Clone the alt text from the current content and enrich with verified short/long from props.altTextContent, but only if they are not already present in the current content. This allows us to preserve any new edits while ensuring verified alt text is included for saving.
       const clonedAltText = parseLatexAltText(fileContent)
       console.log(clonedAltText, "<<clonedAltText>>")

          const clonedAltForSave = JSON.parse(
            JSON.stringify(props.altTextContent || {}),
          );
          console.log(clonedAltForSave, "<<clonedAltForSave before enrichment>>")

          Object.keys(clonedAltForSave).forEach((key) => {
            const saveItem = clonedAltForSave[key];

            if (saveItem?.verified) {
              clonedAltText[key] = {
                ...(clonedAltText[key] || {}),
                short: clonedAltText[key].short,
                long: clonedAltText[key].long,
                verified: true
              };
            }
          });

          console.log(clonedAltText, "<<clonedAltText after enrichment>>")

          console.log(clonedAltForSave, "<<clonedAltForSave before enrichment>>")

          attachInitialAltText(clonedAltText, originalMap, !!originalSource, clonedAltForSave);

          
          if (isAuthor) {
            Object.keys(clonedAltText).forEach((fileKey) => {
              // const altTextServiceXml = altTextFinalXmlCreation(clonedAlt);
              const currentShort =
                clonedAltText[fileKey]?.short?.value ??
                clonedAltText[fileKey]?.short ??
                "";
              const currentLong =
                clonedAltText[fileKey]?.long?.value ?? clonedAltText[fileKey]?.long ?? "";
              // Compare against the Author's initial alt text resolved above.
              const origShort = clonedAltText[fileKey]?.initialShort ?? "";
              const origLong = clonedAltText[fileKey]?.initialLong ?? "";
              const isEdited =
                String(currentShort) !== String(origShort) ||
                String(currentLong) !== String(origLong);
              clonedAltText[fileKey].isEdited = isEdited;
            });
          }

          if (isMC) {
            Object.keys(clonedAltText).forEach((fileKey) => {
              if (!clonedAltText[fileKey]) return;
              const saveItem = clonedAltForSave[fileKey];
              // actionBtn lives in props.altTextContent (clonedAltForSave), not in the LaTeX parse
              const actionBtn =
                saveItem?.actionBtn ??
                (saveItem?.isEdited === true ? "validate" : "skip");
              clonedAltText[fileKey].actionBtn = actionBtn;
              // Author's edited flag travels with the Author's initial alt text.
              if (saveItem?.isEdited === true) {
                clonedAltText[fileKey].isEdited = true;
              }
              // comment also lives in props.altTextContent, carry it into submit payload
              if (saveItem?.comment != null) {
                clonedAltText[fileKey].comment = saveItem.comment;
              }
              if (saveItem?.mcValidated != null) {
                clonedAltText[fileKey].mcValidated = saveItem.mcValidated;
              }
            });

            // An image in the Image List that no figure block references isn't
            // in the LaTeX parse, but the Master Copier can still flag it
            // (typically "create") — carry those decisions over too.
            Object.keys(clonedAltForSave).forEach((fileKey) => {
              const saveItem = clonedAltForSave[fileKey];
              if (clonedAltText[fileKey] || !saveItem?.actionBtn) return;
              clonedAltText[fileKey] = {
                short: null,
                long: null,
                actionBtn: saveItem.actionBtn,
                ...(saveItem.comment != null && { comment: saveItem.comment }),
                ...(saveItem.mcValidated != null && { mcValidated: saveItem.mcValidated }),
              };
            });
          }

          console.log(clonedAltText, "<<clonedAltText with isEdited>>")

          const supplementaryFileNames =
            alttextEnabled && isMC ? await fetchSupplementaryMediaNames(GetDetailData) : [];
          
          let data = {
            htmlcontent: fileContent,
            OutputTexContent: tagInsertion,
            QueryContent: JSON.stringify(authorquerys),
            CommentContent: JSON.stringify(comments),
            // BlobComment: JSON.stringify(blobcomments),
            trackChanges: JSON.stringify(trackchange),
            supplementComments: JSON.stringify(supplementComments || {}),
            supplementary: JSON.stringify(supplementaryData),
            // Author-only: attachment New/Replace details, sent alongside the submit payload.
            ...(isAuthor && { attachmentDetails: JSON.stringify(buildattachmentDetails(props.fileItems)) }),
            // submit-only payload: include isEdited flags without mutating app state
            // (sent whenever the document is in the alt-text flow, as on save)
            ...(altTextFlow && { altTextContent: JSON.stringify(clonedAltText || {}) }),
            ...(alttextEnabled && isMC && { altTextServiceXml: altTextFinalXmlCreation(clonedAltText, supplementComments, props.fileItems, supplementaryFileNames) }),
            istexfile: true,
            docid: docId,
            getjobDetails: GetDetailData,
            activityID: GetDetailData.ActivtyDetails.ActivityID,
            isAutoSave: false,
            ArticleGUID: GetDetailData.Articledetails.ArticleGUID,
            filename: currentFile, // Assuming this is the filename to compile
            editorChangeDetails: {
              trackchanges: {
                deletion: trackSpreate.deletion,
                insertion: trackSpreate.insertion,
                totalCount: trackSpreate.deletion + trackSpreate.insertion,
              },
              comments: trackSpreate.Comment,
              AuthorQuery: trackSpreate.AuthorQuery,
              Attachment: trackSpreate.Attachment,
              textAttacment: trackSpreate.AttachementFilterTxt,
              imageAttachement: trackSpreate.AttachementFilterImage,
              TotalPDFPageCount: totalPage,
            },
            editorChangeFilename: "ArticleChangedDetails.json",
            resourcepath: GetDetailData.Articledetails.ArtResourcePath,
            OutputdirectoryPath: OutputdirectoryPath,
            OutputPathfileName: OutputPathfileName.replace(".xml", ".tex"),
          };
          const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].submit_all_api}`; // Backend endpoint to handle all operations
          const response = await axios.post(url, data);
          if (response.data.is_success === true) {
            setShowprogress(false);

            // toastSuccess(`Submitted Successfully.`);
            navigate(`/notification?docid=${docId}`, {
              state: {
                status: "success",
                role: userProfile.role,
                filename: fullData.Filename,
                journalcode: GetDetailData.jobdetails.JournalCode,
              },
            });
            localStorage.removeItem(`${docId}_init-getdetails`);
            localStorage.removeItem(`${docId}_captchaVerified`);
            localStorage.removeItem(`${docId}_logstatus`);
          } else {
            throw new Error("Submit API returned an error.");
          }
        } catch (error) {
          setShowprogress(false);
          toastError(`Error: ${error.message}`);
        }
      };
      submitFun();
    }
  }, [submitData]);

  // Build a per-attachment summary (keyed by the attachment's own uploaded
  // filename), sent alongside altTextContent at submit time. Image/Media
  // attachments carry their New/Replace decision; every attachment carries
  // its category and comment.
  function buildattachmentDetails(fileItems) {
    const isPresent = (value) => value && value !== "null";
    const content = {};
    (fileItems || []).forEach((item) => {
      if (!item?.Filename || !item?.AttachType) return;
      const entry = {
        filetype: item.AttachType,
        comment: item.Remarks || "",
      };
      if (item.AttachType === "imageAttachment") {
        entry.imageAction = isPresent(item.imageAction) ? item.imageAction : null;
        entry.replaceImageName = isPresent(item.replaceImageName) ? item.replaceImageName : null;
      } else if (item.AttachType === "mediaAttachment") {
        entry.mediaAction = isPresent(item.mediaAction) ? item.mediaAction : null;
        entry.replaceMediaName = isPresent(item.replaceMediaName) ? item.replaceMediaName : null;
      }
      content[item.Filename] = entry;
    });
    return content;
  }

  // Supplementary video/audio/GIF file names, used to pair a caption/AD
  // replacement (e.g. "mmc8-ad.ttml") with the media file it belongs to.
  // Returns [] if the listing can't be fetched.
  async function fetchSupplementaryMediaNames(GetDetailData) {
    try {
      const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].retrievefiles}`;
      const basePath = `${GetDetailData.Articledetails.ArtResourcePath}/Supplementary`;
      const response = await axios.post(url, { InputPath: basePath });
      // Top-level files only, mirroring the Supplementary tab's own list.
      return (response.data || [])
        .map((file) => String(file?.path || ""))
        .filter((path) => path && !path.replace(basePath + "/", "").includes("/"))
        .map((path) => path.split("/").pop());
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  function altTextFinalXmlCreation(altTextContentObj, supplementCommentObj, attachmentItems, supplementaryFileNames = []) {
    // Master Copier actions for media files are stored inside the
    // supplementComment map under this reserved key.
    const ACTIONS_KEY = "__mcActions__";
    const supplementActionObj =
      (supplementCommentObj && supplementCommentObj[ACTIONS_KEY]) || {};

    const validAttachments = (attachmentItems || []).filter(
      (item) => item?.AttachType === "imageAttachment" || item?.AttachType === "mediaAttachment",
    );

    // Master Copier actions/comments only apply to video, audio and GIF files.
    const isSupplementMediaFile = (fileName) => {
      const ext = String(fileName).split(".").pop().toLowerCase();
      const videoExt = ["mp4", "avi", "mov", "wmv", "flv", "webm", "mkv", "m4v", "3gp", "ogv"];
      const audioExt = ["mp3", "wav", "ogg", "aac", "flac", "m4a", "wma"];
      return videoExt.includes(ext) || audioExt.includes(ext) || ext === "gif";
    };

    const hasImages =
      altTextContentObj && Object.keys(altTextContentObj).length > 0;
    const hasSupplements =
      (supplementCommentObj && Object.keys(supplementCommentObj).length > 0) ||
      (supplementaryFileNames || []).some(isSupplementMediaFile);
    const hasAttachments = validAttachments.length > 0;

    if (!hasImages && !hasSupplements && !hasAttachments) {
      return "";
    }

    // Escape XML-reserved characters so comment text can't break the markup
    const escapeXml = (str) =>
      String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");

    // Attachment remarks are stored as HTML — reduce them to plain text.
    const toPlainText = (html) => {
      const raw = isPresent(html) ? String(html) : "";
      if (!raw) return "";
      if (typeof DOMParser !== "undefined") {
        return (new DOMParser().parseFromString(raw, "text/html").body.textContent || "").trim();
      }
      return raw.replace(/<[^>]*>/g, "").trim();
    };

    // <tag>text</tag> on its own line at `indent`, or "" when there's no text.
    const textTag = (tag, text, indent) =>
      text ? `\n${" ".repeat(indent)}<${tag}>${escapeXml(text)}</${tag}>` : "";

    const isPresent = (value) => value && value !== "null";
    const getFileExtension = (name) => String(name || "").split(".").pop().toLowerCase();
    const cleanImageName = (name) => String(name || "").replace(".pdf", "");
    const cleanMediaName = (name) => String(name || "").replace(/\.[^./\\]+$/, "");

    // Caption/subtitle extensions — a "Replace File" target with one of these
    // isn't the media file itself, so its replacement gets filed under the
    // video/audio it's paired with (mirrors the Supplementary tab's own
    // caption-to-media pairing).
    const CAPTION_EXTENSIONS = ["ttml", "vtt", "txt", "srt", "sub", "sbv", "cc", "ass", "ssa"];
    // Which wrapper tag a media replacement gets is based on the extension of
    // the newly attached file itself, per spec: captions/subtitles/plain text
    // -> <replacement-asset>, actual audio/video/gif -> <replacement-media>.
    const REPLACEMENT_ASSET_EXTENSIONS = ["ttml", "vtt", "txt"];

    // Image replacements, keyed by the existing image being replaced (e.g. "gr1").
    const imageReplacementByTarget = {};
    validAttachments
      .filter(
        (item) =>
          item.AttachType === "imageAttachment" &&
          item.imageAction === "replace" &&
          isPresent(item.replaceImageName),
      )
      .forEach((item) => {
        const target = cleanImageName(item.replaceImageName);
        const existing = imageReplacementByTarget[target];
        if (!existing || new Date(item.CreatedOn) > new Date(existing.CreatedOn)) {
          imageReplacementByTarget[target] = item;
        }
      });

    const buildImageReplacementXml = (item) => `
    <replacement-image>
      <replace-image-name>${escapeXml(item.Filename)}</replace-image-name>${textTag("replace-image-comment", toPlainText(item.Remarks), 6)}
    </replacement-image>`;

    let filesXml = "";
    const instructions = [];

    // Image alt-text decisions
    Object.entries(altTextContentObj || {}).forEach(([fileName, data]) => {
      if (!data?.actionBtn) return;

      const cleanName = cleanImageName(fileName);
      const instruction = data.actionBtn;

      instructions.push(instruction);

      const commentXml =
        data.comment != null && String(data.comment).trim() !== ""
          ? `
    <comment>${escapeXml(data.comment)}</comment>`
          : "";

      const imageReplacement = imageReplacementByTarget[cleanName];
      const imageReplacementXml = imageReplacement ? buildImageReplacementXml(imageReplacement) : "";
      if (imageReplacement) delete imageReplacementByTarget[cleanName];

      filesXml += `
  <file>
    <filename>${cleanName}</filename>
    <instruction>${instruction}</instruction>${commentXml}${imageReplacementXml}
  </file>`;
    });

    // Supplementary video/audio/GIF decisions — store comments from both the
    // Author and the Master Copier alongside the file name.
    const supplementComments = supplementCommentObj || {};
    const supplementActions = supplementActionObj || {};
    // Every video/audio/gif gets an entry — including ones the Master Copier
    // never touched (default "skip"), which have no comment or stored action.
    const supplementNames = Array.from(
      new Set([
        ...(supplementaryFileNames || []),
        ...Object.keys(supplementComments),
        ...Object.keys(supplementActions),
      ]),
    )
      .filter((name) => name !== ACTIONS_KEY)
      .filter(isSupplementMediaFile)
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }));

    // Base names of the article's video/audio/gif files (e.g. "mmc8"), longest
    // first so "mmc10" wins over "mmc1" for "mmc10-ad".
    const knownMediaBases = Array.from(
      new Set(
        [...(supplementaryFileNames || []).filter(isSupplementMediaFile), ...supplementNames].map(
          cleanMediaName,
        ),
      ),
    ).sort((a, b) => b.length - a.length);

    // A caption/AD file ("mmc8-ad.ttml", "mmc8-cc.vtt", "mmc8.txt") belongs to
    // the media file whose base name it starts with, followed by a separator
    // or nothing at all.
    const resolveMediaTargetBase = (rawTargetName) => {
      const base = cleanMediaName(rawTargetName);
      const ext = getFileExtension(rawTargetName);
      if (!CAPTION_EXTENSIONS.includes(ext)) return base;
      const matched = knownMediaBases.find(
        (b) => base === b || (base.startsWith(b) && /[-_.\s]/.test(base[b.length])),
      );
      // Best-effort fallback when the media listing is unavailable: strip a
      // trailing "-suffix" (e.g. "mmc4-ad" -> "mmc4").
      return matched || base.replace(/[-_][^-_]+$/, "");
    };

    // Media replacements grouped by the video/audio/gif they belong to. Each
    // replaced file (the video itself, its .ttml, .vtt, .txt, ...) keeps only
    // its latest replacement.
    const mediaReplacementByTarget = {};
    validAttachments
      .filter(
        (item) =>
          item.AttachType === "mediaAttachment" &&
          item.mediaAction === "replace" &&
          isPresent(item.replaceMediaName),
      )
      .forEach((item) => {
        const target = resolveMediaTargetBase(item.replaceMediaName);
        const group = (mediaReplacementByTarget[target] ??= {});
        const existing = group[item.replaceMediaName];
        if (!existing || new Date(item.CreatedOn) > new Date(existing.CreatedOn)) {
          group[item.replaceMediaName] = item;
        }
      });

    // Captions/subtitles/plain text (by the new file's extension) go under
    // <replacement-asset>, actual audio/video/gif under <replacement-media>.
    const buildMediaReplacementXml = (group) => {
      const items = Object.values(group || {}).sort((a, b) =>
        String(a.Filename).localeCompare(String(b.Filename)),
      );
      const isAsset = (item) => REPLACEMENT_ASSET_EXTENSIONS.includes(getFileExtension(item.Filename));
      const buildGroup = (wrapperTag, entryTag, prefix, entries) =>
        entries.length
          ? `
    <${wrapperTag}>${entries
            .map(
              (item) => `
      <${entryTag}>
        <${prefix}-name>${escapeXml(item.Filename)}</${prefix}-name>${textTag(`${prefix}-comment`, toPlainText(item.Remarks), 8)}
      </${entryTag}>`,
            )
            .join("")}
    </${wrapperTag}>`
          : "";
      return (
        buildGroup("replacement-asset", "replaceAsset", "replace-asset", items.filter(isAsset)) +
        buildGroup("replacement-media", "replaceMedia", "replace-media", items.filter((i) => !isAsset(i)))
      );
    };

    supplementNames.forEach((fileName) => {
      const fileComments = supplementComments[fileName] || [];
      const authorCommented = fileComments.some((c) => c.role === "Author");
      // Same default as the Supplementary tab shows: an explicit Master Copier
      // choice wins; otherwise a pending replacement or an Author comment
      // means "validate", else "skip".
      const instruction =
        supplementActions[fileName] ||
        (mediaReplacementByTarget[cleanMediaName(fileName)] || authorCommented ? "validate" : "skip");

      instructions.push(instruction);

      const commentsXml = fileComments
        .filter((c) => c.text != null && String(c.text).trim() !== "")
        .map(
          (c) =>
            `
    <comment>${escapeXml(c.text)}</comment>`,
        )
        .join("");

      // Store the media file name without its extension (e.g. "mmc4.mp4" -> "mmc4").
      const cleanSupplementName = cleanMediaName(fileName);

      const mediaReplacement = mediaReplacementByTarget[cleanSupplementName];
      const mediaReplacementXml = mediaReplacement ? buildMediaReplacementXml(mediaReplacement) : "";
      if (mediaReplacement) delete mediaReplacementByTarget[cleanSupplementName];

      filesXml += `
  <file>
    <filename>${escapeXml(cleanSupplementName)}</filename>
    <instruction>${instruction}</instruction>${commentsXml}${mediaReplacementXml}
  </file>`;
    });

    // Any replacement target that had no existing <file> entry of its own yet
    // still needs one — forced to "validate" since a replacement always needs
    // the Master Copier's review.
    Object.entries(imageReplacementByTarget).forEach(([cleanName, item]) => {
      instructions.push("validate");
      filesXml += `
  <file>
    <filename>${escapeXml(cleanName)}</filename>
    <instruction>validate</instruction>${buildImageReplacementXml(item)}
  </file>`;
    });

    Object.entries(mediaReplacementByTarget).forEach(([cleanName, item]) => {
      instructions.push("validate");
      filesXml += `
  <file>
    <filename>${escapeXml(cleanName)}</filename>
    <instruction>validate</instruction>${buildMediaReplacementXml(item)}
  </file>`;
    });

    const isRouteAltxt =
      instructions.length > 0 && !instructions.every((inst) => inst === "skip");

    // Any Media attachment (new or replace) means downstream video assets
    // need to be re-validated.
    const validatevideoAsset = validAttachments.some(
      (item) => item.AttachType === "mediaAttachment",
    );

    // "New" attachments have no existing target to nest into, so they still
    // get a lightweight manifest entry.
    const buildNewAttachmentGroup = (tagName, items) => {
      let groupXml = "";
      items.forEach((item, idx) => {
        const n = idx + 1;
        groupXml += `
  <${tagName}>
    <filename${n}>${escapeXml(item.Filename)}</filename${n}>
    <Instruction>${escapeXml(toPlainText(item.Remarks))}</Instruction>
  </${tagName}>`;
      });
      return groupXml;
    };

    const newImages = validAttachments.filter(
      (item) => item.AttachType === "imageAttachment" && item.imageAction === "new",
    );
    const newMedia = validAttachments.filter(
      (item) => item.AttachType === "mediaAttachment" && item.mediaAction === "new",
    );

    let attachmentsXml = "";
    attachmentsXml += buildNewAttachmentGroup("newimage", newImages);
    attachmentsXml += buildNewAttachmentGroup("newmedia", newMedia);

    const attachmentsBlock = attachmentsXml
      ? `
  <attachments>${attachmentsXml}
  </attachments>`
      : "";

    return `
<alt-text-service>
  <isRouteAltxt>${isRouteAltxt}</isRouteAltxt>
  <ValidatevideoAsset>${validatevideoAsset}</ValidatevideoAsset>
  ${filesXml}${attachmentsBlock}
</alt-text-service>`.trim();
  }

  const handleSubmit = async () => {
    // Validate alt text verification before submitting (only when alttextEnabled)
    if (
      alttextEnabled &&
      props.validateAltTextVerification &&
      !props.validateAltTextVerification()
    ) {
      // validateAltTextVerification opens the tab (Image or Supplementary)
      // holding the first problem.
      return;
    }

    setConfirm(false);
    compileCode("submitHandle");
  };

  async function fetchPageInfoData(OutputPath) {
    const fileurl = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].blobFileExistorNot}`;
    const filedata = { InputPath: OutputPath.replace(".xml", ".pgInfo") };
    const isFileexist = await axios.post(fileurl, filedata);
    if (isFileexist.data.exist) {
      const response = await axios.post(
        `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_preview_file}`,
        filedata,
      );
      return response.data;
    }
    return "";
  }

  // initialShort / initialLong = the alt text as it stood in the Author's
  // initial .tex, before any Author edit. It has to reach the Master Copier
  // submission unchanged, so:
  //  - Author and Master Copier re-read it from the Author-stage input .tex
  //    (originalMap); if that couldn't be loaded, the stored value is kept.
  //  - Any other role keeps the stored value (written from the Author's
  //    initial .tex) and only uses its own input when nothing is stored yet.
  // The current value is the last resort, for an image with no record at all.
  function attachInitialAltText(altTextMap, originalMap, originalLoaded, storedMap) {
    const preferStored = !originalLoaded || !(isAuthor || isMC);
    const textOf = (field) => field?.value ?? (typeof field === "string" ? field : undefined);
    Object.keys(altTextMap).forEach((fileKey) => {
      const item = altTextMap[fileKey];
      if (!item) return;
      const stored = storedMap?.[fileKey];
      const orig = originalMap?.[fileKey];
      const pick = (storedValue, origValue, currentValue) =>
        (preferStored
          ? storedValue ?? origValue
          : origValue ?? storedValue) ?? currentValue ?? "";
      item.initialShort = pick(stored?.initialShort, textOf(orig?.short), textOf(item.short));
      item.initialLong = pick(stored?.initialLong, textOf(orig?.long), textOf(item.long));
    });
  }

  async function getInitialLatexContent() {
    try {
      let GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
    var GetDetailData = JSON.parse(GetDetailDataString);
    let OutputPath = GetDetailData.Articledetails.OutputPath;
    let InputPath = OutputPath.replace("/Output/", "/Input/").replace(".xml", ".tex");
    // The Master Copier (stage 128) reads the Author stage's (83) input .tex.
    // If the path doesn't carry the MC stage, the replace would silently fall
    // back to the MC's own input (= the Author's output) — return nothing
    // instead so the caller keeps the stored Author initial alt text.
    if (userProfile.role === "Master Copier" && !InputPath.includes('/128/')) {
      console.warn("Author-stage input path not found for Master Copier:", InputPath);
      return undefined;
    }
    let initialProofTexFile = userProfile.role === "Master Copier"? InputPath.replace('/128/', '/83/') : InputPath;
    // console.log("<init L2QA replacement>", InputPath);
    let InputFileBlobPath = `${initialProofTexFile}`;
    let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_preview_file}`;
    const data = { InputPath: InputFileBlobPath };
    const response = await axios.post(url, data);
    const texContent = response.data.data || response.data;
    const result = processHTMLString(texContent);
    console.log("<Initial LaTeX content fetched and processed>", result);
    return result.modifiedHTML;
            
    } catch (error) {
      console.error("Error while fetching the Initial file:", error);
      toastError("Error while fetching the Initial file");
    }
  }


  function extractTotalPage(pageInfoData) {
    const totalPageMatch = pageInfoData.match(/<TotalPage>(\d+)<\/TotalPage>/);
    return totalPageMatch ? parseInt(totalPageMatch[1], 10) : 0;
  }

  useEffect(() => {
    if (fullData) {
      setCurrentFile(fullData.Filename);
      if (editorContent.length === 0) {
        setFileContent(fullData.Content);

        // Capture the initial LaTeX content once for submit-time comparisons
        if (!initialLatexRef.current && fullData?.Content) {
          initialLatexRef.current = fullData.Content;
        }

        const fetchPdfContent = async () => {
          try {
            const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].pdfContent}`;

            // Get OutputPath and replace .xml with .pdf
            const pdfPath =
              fullData.TocDetails.oData.Articledetails.OutputPath.replace(
                ".xml",
                ".pdf",
              );

            const payload = {
              InputPath: pdfPath,
            };

            const response = await axios.post(url, payload);
            setPdfContent(response.data);
            setShowpdf(true);
          } catch (error) {
            console.error("Error fetching PDF content:", error);
          }
        };

        fetchPdfContent();

        if (userProfile?.role === "Author" && trackContents !== "") {
          setFileContent(trackContents);
        }
      }
    }
    if (editorContent !== "") {
      setFileContent(editorContent);
    }
  }, [fullData, editorContent, trackContents]);

  useEffect(() => {
    if (compileAction === true) {
      let Timer = null;
      if (timeComplete === false) {
        Timer = setInterval(() => {
          setTime((prevState) => prevState + 1);
        }, 1000);
      } else {
        clearInterval(Timer);
      }
      return () => {
        clearInterval(Timer);
      };
    }
  }, [compileAction, timeComplete]);

  useEffect(() => {
    if (pdfContent) {
      let byteCharacters;
      try {
        byteCharacters = atob(pdfContent);
      } catch (e) {
        console.error("PDF content is not valid base64:", e);
        return;
      }
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [pdfContent]);

  const formatTime = (totalSeconds) => {
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      "0",
    );
    const seconds = String(totalSeconds % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const pdfDownlad = async () => {
    try {
      setDownloadBar(true);
      const docId = userProfile.docid;
      const linkPath = JSON.parse(
        localStorage.getItem(`${docId}_init-getdetails`),
      );
      const pdfReplace = linkPath.Articledetails.OutputPath.replace(
        ".xml",
        ".pdf",
      );
      //const url2 = linkPath.Articledetails.blobDomain + pdfReplace; // Replace with your file URL
      const data = {
        InputPath: pdfReplace,
      };
      const isFileexist = await axios.post(
        `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].blobFileExistorNot}`,
        data,
      );
      if (isFileexist.data.exist === true) {
        const response = await axios.post(
          `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].download}`,
          {
            blobUrl: pdfReplace,
            type: "application/pdf",
          },
          {
            responseType: "blob", // Important
          },
        );
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" }),
        );
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `${linkPath.Articledetails.ArticleName}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        setDownloadBar(false);
        toastSuccess(`File Downloaded successfully.`);
      } else {
        setDownloadBar(false);
        toastError(
          `Compilation Required: Please compile the document before downloading the PDF.`,
        );
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      setDownloadBar(false);
      toastError(`File Downloaded Error.`);
    }
  };

  const validationcheck = async (value, submitvalue) => {
    try {
      let validitionlist = [];
      let count = 0;
      if (value !== "compilercheck") {
        if (userProfile.role === "Author" || userProfile.role === "Editor") {
          let authorquerydata = authorQuery;
          for (const query of authorquerydata) {
            // Notice-type queries only need the "Reviewed" acknowledgement.
            if (query?.reviewOnly) {
              if (query?.reviewed !== true) {
                validitionlist.push({
                  serial: count + 1,
                  message: `${query.label} : Please review the note before submitting.`,
                  position: "Query",
                });
                count++;
              }
              continue;
            }
            // Auto-generated alt-text queries need either the "Verified" acknowledgement
            // or a reply — skip the verified check once a reply has been given.
            if (query?.altTextQuery) {
              const hasReply = query?.replies?.length > 0;
              if (query?.verified !== true && !hasReply) {
                validitionlist.push({
                  serial: count + 1,
                  message: `${query.label} : Please verify the alt-text before submitting.`,
                  position: "Query",
                });
                count++;
              }
              continue;
            }
            if (query?.replies === undefined || query?.replies.length === 0) {
              if (
                query?.repliesMark === undefined ||
                query?.repliesMark === false
              ) {
                if (
                  query?.aqCheck === undefined ||
                  query?.answerCheck === undefined ||
                  query?.answerCheck === "no"
                ) {
                  validitionlist.push({
                    serial: count + 1,
                    message: `${query.label} : Please respond to the query before submitting.`,
                    position: "Query",
                  });
                  count++;
                }
              }
            }
          }
        }
      }
      if (userProfile.role === "Author" || userProfile.role === "Editor") {
        if (fileContent !== "") {
          // Step 1: Normalize multi-line citations by merging broken \cite{...} commands
          let latexLines = fileContent.split("\n");
          let normalizedLines = [];
          let currentCitation = "";
          let currentLineNumber = -1;

          // Merge broken citations while preserving line numbers
          latexLines.forEach((line, index) => {
            if (currentCitation) {
              currentCitation += " " + line.trim();
              if (
                currentCitation.match(
                  /\\cite(t|p|alp|alt|author|year)?\*?(?:\[[^\]]*\])*\{[^}]+\}/,
                )
              ) {
                normalizedLines.push({
                  text: currentCitation,
                  lineNumber: currentLineNumber,
                });
                currentCitation = ""; // Reset
              }
            } else {
              if (
                line.match(
                  /\\cite(t|p|alp|alt|author|year)?\*?(?:\[[^\]]*\])*\{[^}]*$/,
                )
              ) {
                currentCitation = line.trim();
                currentLineNumber = index + 1; // Store initial line number
              } else {
                normalizedLines.push({ text: line, lineNumber: index + 1 });
              }
            }
          });

          // Step 2: Extract all citations with their line numbers
          let citations = [];
          normalizedLines.forEach(({ text, lineNumber }) => {
            const matches = text.match(
              /\\cite(t|p|alp|alt|author|year)?\*?(?:\[[^\]]*\])*\{([^}]+)\}/g,
            );
            if (matches) {
              matches.forEach((match) => {
                const citationKeys = match
                  .replace(
                    /\\cite(t|p|alp|alt|author|year)?\*?(?:\[[^\]]*\])*\{|\}/g,
                    "",
                  )
                  .split(",")
                  .map((citation) => citation.trim());
                citationKeys.forEach((citation) => {
                  citations.push({ value: citation, lineNumber });
                });
              });
            }
          });

          // // Step 3: Extract all \bibitem entries with their line numbers
          // let bibItems = [];
          // latexLines.forEach((line, index) => {
          //     const bibItemMatch = line.match(/\\bibitem(?:\[[^\]]*\])?\{([^}]+)\}/);
          //     if (bibItemMatch) {
          //         bibItems.push({ value: bibItemMatch[1].trim(), lineNumber: index + 1 });
          //     }
          // });

          // Step 3: Extract all \bibitem entries with their line numbers
          let bibItems = [];
          let currentEntry = "";
          let startLine = null;

          latexLines.forEach((line, index) => {
            const trimmedLine = line.trim();

            // Skip commented \bibitem lines (with or without space after %)
            if (/^%\s*\\bibitem/.test(trimmedLine)) return;

            // Start of a new \bibitem block
            if (line.includes("\\bibitem")) {
              currentEntry = line;
              startLine = index + 1;
            } else if (currentEntry) {
              currentEntry += " " + line; // Concatenate continuation lines
            }

            // Use multiline-safe regex with dotAll flag (`s`)
            if (currentEntry) {
              const bibItemMatch = currentEntry.match(
                /\\bibitem(?:\[[^\]]*?\])?\{([^}]+)\}/s,
              );
              if (bibItemMatch) {
                bibItems.push({
                  value: bibItemMatch[1].trim(),
                  lineNumber: startLine,
                });
                currentEntry = "";
                startLine = null;
              }
            }
          });

          // Step 4: Find missing citations (citations without bibitem entries)
          let missingReferences = citations.filter(
            (citation) =>
              !bibItems.some((bibItem) => bibItem.value === citation.value),
          );

          // Step 5: Find bibitems without corresponding citations
          let missingCitations = bibItems.filter(
            (bibItem) =>
              !citations.some((citation) => citation.value === bibItem.value),
          );

          // Step 6: Output missing citations with line numbers
          missingReferences.forEach((missingRef) => {
            validitionlist.push({
              serial: count + 1,
              message: `Citation (${missingRef.value}) found without a corresponding reference.`,
              position: Number(missingRef.lineNumber),
            });
            count++;
          });

          // Step 7: Output references without citations with their line numbers
          missingCitations.forEach((missingCite) => {
            validitionlist.push({
              serial: count + 1,
              message: `Reference (${missingCite.value}) found without a corresponding citation.`,
              position: Number(missingCite.lineNumber),
            });
            count++;
          });
        }
      }

      // Client-requested removal (kept commented, not deleted, in case this
      // needs to come back): Image Alt Text Verification Check only for
      // Author at the time of submission (only when alttextEnabled). This
      // depended on the "Verified the Alt Text" checkbox (also commented out
      // in imagelist.js), which no longer sets data.verified — so leaving
      // this active would block every submission.
      // if ( alttextEnabled && submitvalue === "submitHandle" && Object.keys(props.altTextContent || {}).length > 0 && isAuthor ) {
      //   for (const [fileName, data] of Object.entries(props.altTextContent)) {
      //     if ((data?.short || data?.long) && data?.verified !== true) {
      //       validitionlist.push({
      //         serial: count + 1,
      //         message: `${fileName} : Please validate the alternative text for images before submitting.`,
      //         position: "Image",
      //         fileName,
      //       });
      //       count++;
      //     }
      //   }
      // }

      // Comment + "Validated by MC" check for Master Copier at submission (only when alttextEnabled).
      // Every Create/Validate image must have a non-empty comment and be marked validated.
          if ( alttextEnabled && submitvalue === "submitHandle" && Object.keys(props.altTextContent || {}).length > 0 && isMC ) {
            for (const [fileName, data] of Object.entries(props.altTextContent)) {
              const action = data?.actionBtn;
              if (action !== "validate" && action !== "create") continue;

              // Comment is mandatory only for the "create" action. For "validate"
              // the Master Copier is confirming existing alt text, so a comment
              // is optional.
              const commentMissing =
                action === "create" &&
                (!data?.comment || String(data.comment).trim() === "");
              const notValidated = !data?.mcValidated;
              if (!commentMissing && !notValidated) continue;

              const missing = [];
              if (commentMissing) missing.push("a comment");
              if (notValidated) missing.push('"Validated by MC" confirmation');

              validitionlist.push({
                serial: count + 1,
                message: `${fileName} : Please add ${missing.join(" and ")} for the "${action}" action before submitting.`,
                position: "Image",
                fileName,
              });
              count++;
            }
          }

      // Same check for Create/Validate supplementary media files (the
      // Supplementary tab reports which ones still need it).
      if (alttextEnabled && submitvalue === "submitHandle" && isMC) {
        (props.supplementMcIssues || []).forEach(({ fileName, action, commentMissing, notValidated }) => {
          const missing = [];
          if (commentMissing) missing.push("a comment");
          if (notValidated) missing.push('"Validated by MC" confirmation');
          validitionlist.push({
            serial: count + 1,
            message: `${fileName} : Please add ${missing.join(" and ")} for the "${action}" action before submitting.`,
            position: "Supplementary",
            supplementFileName: fileName,
          });
          count++;
        });
      }

      if (validitionlist.length === 0 && submitvalue === "submitHandle") {
        setConfirm(true);
      } else {
        props.validation(validitionlist);
        return validitionlist;
      }
    } catch (error) {
      toastError(`Error validationcheck:, ${error}`);
      //console.error('Error validationcheck:', error);
    }
  };
  useEffect(() => {
    renderCount.current += 1;
    console.log(`CodeMirrorEditor rendered (count: ${renderCount.current})`);
    // refreshDocData();
  }, [userProfile?.docid]);

  useEffect(() => {
    if (!readOnly) {
      if (saveStatus || saveTrigger) {
        //Set up interval to auto-save every 5 seconds
        const intervalId = setInterval(() => {
          if (saveButton.current) {
            saveButton.current.click();
          }
        }, 120000);
        // Clean up the interval on component unmount
        return () => clearInterval(intervalId);
      }
    }
  }, [saveStatus, saveTrigger]);

  useEffect(() => {
    if (microSave === true) {
      onSave();
      setMicroSave(false);
    }
  }, [microSave]);

  const PdfcompleteLoader = () => {
    setCompileAction(false);
  };

  return (
    <div className="pdf-viewer">
      <div
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
        style={{
          position: "absolute",
          left: "-10000px",
          width: "1px",
          height: "1px",
          overflow: "hidden",
        }}
      >
        {announcement}
      </div>
      <div className={`modal-outer ${showconfirm ? "active" : ""}`}>
        <div className="modal confirmation-popup">
          <div className="modal-header">
            <h1>Confirm Submit</h1>
            <button className="modal-close-btn" tabIndex={0} aria-label="Close" onClick={() => setConfirm(false)}><FaTimes /></button>
          </div>
          <div className="modal-body">
            <div className="change-group">
              <div className="change-status">
                <div className="change-status-inner">
                  <p>
                    {userProfile.role} changes:{" "}
                    {userProfile.role === "Editor"
                      ? trackSpreate.editorTrackTotal
                      : trackSpreate.deletion + trackSpreate.insertion}
                  </p>
                  <div className="change-status-info">
                    <p>
                      Insertion:{" "}
                      {userProfile.role === "Editor"
                        ? trackSpreate.insertionEditor
                        : trackSpreate.insertion}
                    </p>
                    <p>
                      Deletion:{" "}
                      {userProfile.role === "Editor"
                        ? trackSpreate.deletionEditor
                        : trackSpreate.deletion}
                    </p>
                  </div>
                </div>
              </div>
              <div className="change-status">
                <div className="change-status-inner">
                  <p>
                    Comments:{" "}
                    {userProfile.role === "Editor"
                      ? trackSpreate.commentEditor
                      : trackSpreate.Comment}
                  </p>
                </div>
              </div>
              <div className="change-status">
                <div className="change-status-inner">
                  <p>Query Responses: {trackSpreate.AuthorQuery}</p>
                </div>
              </div>
              <div className="change-status">
                <div className="change-status-inner">
                  <p>
                    Attachment:{" "}
                    {userProfile.role === "Editor"
                      ? trackSpreate.AttachmentEditor
                      : trackSpreate.Attachment}
                  </p>
                  <div className="change-status-info">
                    <p>
                      Text and Comments: {trackSpreate.AttachementFilterTxt}
                    </p>
                    <p>Image: {trackSpreate.AttachementFilterImage}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="primary"
              ref={yesBtnRef}
              tabIndex={0}
              onClick={handleSubmit}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleSubmit();
                }
              }}
            >
              Yes
            </button>
            <button
              className="outline-secondary"
              tabIndex={0}
              onClick={() => setConfirm(false)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setConfirm(false);
                }
              }}
            >
              No
            </button>
          </div>
        </div>
      </div>
      <div className={`modal-outer ${showProgress ? "active" : ""}`}>
        <div className="modal confirmation-popup">
          <div className="modal-header">
            <h1>Please Wait</h1>
          </div>
          <div className="modal-body">
            <p>{progressDetails}</p>
            <span className="loader"></span>
          </div>
        </div>
      </div>
      <div className="pdf-btns-group">
        <div></div>
        <div className="pdf-btns-group-inner">
          <Button
            className="com-btn firststep"
            onClick={() => {
              compileCode();
              setAnnouncement("Compile button Clicked");
            }}
            ref={CompileButton}
          >
            <BiRefresh />
            <span>
              {" "}
              {timer === true ? `Compile - ${formatTime(time)}` : "Compile"}
            </span>
          </Button>
          <Button
            className="com-btn save-btn"
            onClick={() => {
              onSave();
              setAnnouncement("Save button clicked");
            }}
            ref={saveButton}
          >
            <FaFloppyDisk /> Save
          </Button>
          <Button
            className="com-btn submit-btn tenthstep"
            onClick={() => {
              validationcheck("", "submitHandle");
              setAnnouncement("Submit button cicked");
            }}
          >
            <FaCircleCheck /> Submit
          </Button>
          <Button
            className="switchbutton"
            onClick={() => setLayout("editoronly")}
          >
            {" "}
            <FaCode /> Switch to editor
          </Button>
        </div>
      </div>
      {compileAction === true ? (
        <div className="preview_animation">
          <div className="loadPDF">
            <p>
              <u></u>
              <u></u>
              <u></u>
              <u></u>
            </p>
            <p>
              <u></u>
              <u></u>
              <u></u>
              <u></u>
            </p>
            {pdfStatus === "success" ? (
              <FaCheckCircle className="success" />
            ) : pdfStatus === "error" ? (
              <FaExclamationCircle className="error" />
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        ""
      )}
      <div className={showPdf ? "pdf-area active" : "pdf-area"}>
        {downloadBar ? (
          <div className="pdf_download_popup_outer">
            <div className="pdf_download_popup">
              <p>PDF download.</p>
              <div className="progess_bar">
                <div
                  className="progess_bar_inner"
                  style={{ width: `${downloadPercentage}%` }}
                ></div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {/* <div className="pdf-container" ref={containerRef} style={{ overflowX: 'scroll', overflowY: 'scroll' }} /> */}
        <PDFViewerComponent
          pdfUrl={pdfUrl}
          docid={userProfile.docid}
          completeLoader={PdfcompleteLoader}
        />
      </div>
    </div>
  );
});
export default PdfEditor;
